










import Vue from 'vue'
import Component from 'vue-class-component'
import { loggerFor } from '@/shared/utils/logger'
import { DialogService } from '@/shared/dialog/dialog-service'
import { Injector } from '@/config/dependency-injection'
import DevelopmentSettingsModal from '@/shared/development/components/development-settings-modal.vue'

@Component({
  components: { DevelopmentSettingsModal },
})
export default class DevelopmentSettingsToggle extends Vue {
  public development = false

  private dialogService = Injector.get(DialogService)
  private logger = loggerFor('DevelopmentSettingsToggle')

  public mounted() {
    this.development = process.env.NODE_ENV === 'development'

    if (this.development) {
      this.logger.info('Development mode is active')
    }
  }

  public openSettings() {
    this.dialogService.open(DevelopmentSettingsModal)
  }
}
